import React from 'react';

const Resources = () => {
  return (
    <div className="resources">
      <div className="container">
        <h1>Resources</h1>
        <p>Helpful resources for parents and families.</p>
        
        <div className="resource-links">
          <h2>External Resources</h2>
          <ul>
            <li>
              <a href="https://elchc.org" target="_blank" rel="noopener noreferrer">
                ELCHC.ORG
              </a>
            </li>
            <li>
              <a href="https://elcpolk.org" target="_blank" rel="noopener noreferrer">
                ELCPOLK.ORG
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Resources;